var map = {
	"./alarm-clock.svg": 47767,
	"./alert-circle.svg": 62912,
	"./align-center.svg": 19000,
	"./align-left.svg": 5204,
	"./align-right-01.svg": 10181,
	"./align-right.svg": 35579,
	"./arrow-narrow-right.svg": 30059,
	"./cc.svg": 27185,
	"./check-circle.svg": 66258,
	"./check.svg": 65957,
	"./chromakey-off.svg": 42626,
	"./chromakey-settings.svg": 19660,
	"./chromakey.svg": 89170,
	"./clock.svg": 75348,
	"./copy.svg": 10868,
	"./cross-circle.svg": 27814,
	"./dots-vertical-primary.svg": 54719,
	"./dots-vertical.svg": 41042,
	"./file.svg": 56369,
	"./font-decrease.svg": 5149,
	"./font-family.svg": 71453,
	"./font-increase.svg": 58965,
	"./font-size.svg": 24938,
	"./globe.svg": 93806,
	"./keyboard.svg": 18884,
	"./loading.svg": 61685,
	"./logout.svg": 44793,
	"./microphone-01.svg": 20605,
	"./microphone-off-01.svg": 66661,
	"./moon.svg": 28784,
	"./narrower.svg": 8535,
	"./palette.svg": 35472,
	"./pencil.svg": 25268,
	"./settings-slider.svg": 52866,
	"./sparkle.svg": 90463,
	"./stand.svg": 28849,
	"./sun.svg": 77355,
	"./theme.svg": 47678,
	"./transcripts.svg": 97592,
	"./user-plus.svg": 68823,
	"./users-plus.svg": 97770,
	"./users.svg": 38881,
	"./volume-max.svg": 17704,
	"./volume-x.svg": 92486,
	"./wider.svg": 4152
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 12347;